import React from 'react'
import './AgeTitle.css'

function AgeTitle (props) {
  return (
    <h2 className="age-title">{props.text}</h2>
  );
};

export default AgeTitle;